import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { LocalStorageService } from "./local-storage.service";
import { KeyTriggerSession, LocalStorageKey } from '@core/helper/local-storage.helper';
import { getFirstURL } from '@core/helper';
import { NavigateRouting } from "@core/configs";

@Injectable({ providedIn: 'root' })
export class LoginFlowService {
  constructor(
    private router: Router,
    private localStorageService: LocalStorageService
  ) { }

  async handleLoginSuccess({loginRo, menuRo}: any): Promise<boolean> {
    if (!loginRo) {
      this.router.navigate([NavigateRouting.authConsoleLogin]);
      return false;
    }

    this.localStorageService.setUserSession(loginRo);
    this.localStorageService.setMenu(menuRo);
    this.localStorageService.trigger(KeyTriggerSession.SET_TOKEN);
    sessionStorage.setItem(LocalStorageKey.SESSION_LOGIN, LocalStorageKey.SESSION_LOGIN);
    const url = getFirstURL();
    this.router.navigate([url]);
    return true;
  }
    
}